import { storageKeys } from 'config/settings.json';

const KEY = storageKeys.fastTrackData.name;

// TODO: Currently replicates the original functionality of storing fast track data in localStorage. Should be replaced by LocalStorage (or future replacement thereof)
// Stored in react-native-storage wire format { data: {...}, expires: null }
// so StorageHandler.remove(storageKeys.fastTrackData) can clean it up correctly.
export const fastTrackData = <T>(key: string, value?: unknown): T | null => {
  const raw = localStorage.getItem(KEY);
  const parsed = raw ? JSON.parse(raw) : null;
  // Support both the new wire format and the legacy plain-object format
  const data = (parsed?.data ?? parsed ?? {}) as Record<string, unknown>;

  if (value === undefined) {
    return (data[key] ?? null) as T | null;
  }

  data[key] = value;
  localStorage.setItem(KEY, JSON.stringify({ data, expires: null }));
  return null;
};
